module.exports = __webpack_public_path__ + "static/media/oauth_api_en.40b12408.md";